var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'app--extension': _vm.isExtension },attrs:{"id":"app"}},[(_vm.loaded)?[_c('router-view')]:(_vm.showLoading)?_c('VueLoadingIndicator',{staticClass:"overlay fixed big"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }